import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';
import styled from 'styled-components';

import { IEventStoreState } from '../../store/event/types';
import { UserEventItem } from './userEventItem';
import { PopUp } from '../../store/animations';

type UserEventsListType = {
  events: Array<IEventStoreState>;
};

export const UserEventsList: FC<UserEventsListType> = ({ events }) => (
  <AnimatePresence>
    <EventsList variants={PopUp} initial={'enter'} animate={'exit'}>
      {events.map((event, index) => (
        <EventsListItem key={index}>
          <UserEventItem event={event} />
        </EventsListItem>
      ))}
    </EventsList>
  </AnimatePresence>
);

const EventsList = styled(motion.ul)`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const EventsListItem = styled.li`
  margin-bottom: 10px;
`;
